import moment from 'moment';
import { Button, Col, Result, Row, Skeleton } from 'antd';
import { isMobile } from 'react-device-detect';
import React, { useEffect, useState } from 'react';
import { Link, params, useParams } from 'react-router-dom';
import { CampaignDelete } from '../../apis/Brand/Campaigns/CampaignDelete';
import { CampaignList } from '../../apis/Brand/Campaigns/CampaignList';
import CampaignCardComponent from '../../components/Brand/Campaign/CampaignCardComponent';
import CampignIntroComponent from '../../components/Brand/CampignIntroComponent';
import BrandTopSubHeaderComponent from '../../components/Brand/Common/BrandTopSubHeaderComponent';
import PlatformIconRender from '../../components/Common/PlatformIconRender';
import BrandBaseLayoutComponent from '../../components/Layout/Brand/BrandBaseLayoutComponent';
import { useGlobalState } from '../../store/state';
import CampaignCountsComponent from '../../components/Brand/Home/CampaignCountsComponent';
import CampaignEarningsComponent from '../../components/Influencers/Home/CampaignEarningsComponent';
import CampaignCreditsComponent from '../../components/Brand/Home/CampaignCreditsComponent';

export const BrandCompanyPage = () => {
  const params = useParams();
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');

  const [loading, setLoaing] = useState(true);
  const [campList, setCampList] = useState({
    campaigns: [],
  });
  const [baseConfig, setBaseConfig] = useState({
    type: 'all',
    page: 1,
  });
  const getCampiagnList = (type, page) =>{
    CampaignList(
      user.accessToken,
      company.selected.id,
      { type: type, page: page },
    ).then(({ response })=>{
      console.log('retrived Data', response);
      setCampList({
        ...campList,
        ...response,
      });
      setLoaing(false);
    });
  };

  const deleteDraft = (campId) =>{
    console.log('camp', campId);
    console.log('pars', params.companyId);
    CampaignDelete(user.accessToken, {
      campaignid: campId,
      brand: params.companyId,
    }).then(({ response }) =>{
      console.log('res', response);
      getCampiagnList();
    });
  };

  useEffect(() =>{ // load all list first time
    // console.log("props",params)
    getCampiagnList();
  }, []);

  return (
    <BrandBaseLayoutComponent>
      {/* <BrandTopSubHeaderComponent className="p-3 sticky">
                Welcome!
            </BrandTopSubHeaderComponent> */}
      {loading ?(
        <div style={{ padding: 14 }}>
          <Row gutter={16}>
            <Col span={14}>
              <Skeleton paragraph={{ rows: 4 }}/>
            </Col>
            <Col span={10}>
              <Skeleton paragraph={{ rows: 4 }}/>
            </Col>
            <Col span={8}>
              <Skeleton paragraph={{ rows: 4 }}/>
            </Col>
            <Col span={8}>
              <Skeleton paragraph={{ rows: 4 }}/>
            </Col>
            <Col span={8}>
              <Skeleton paragraph={{ rows: 4 }}/>
            </Col>
          </Row>
        </div>
      ):(
        <div style={{ padding: 14 }}>
          <Row gutter={16}>

            <Col span={24}>
              <CampignIntroComponent
                title="This is your new space to grow your Brand"
                subtext="Create campiagn to promote your brand with our digital Influencers"
                image="/images/campaign-intro.svg"
                colSize={9}
              >
                <Link to={`/brand/${params.companyId}/campaign/create`}
                  disabled
                  className="common_button outlined">Create Campaign</Link>
              </CampignIntroComponent>
            </Col>
            {
              campList.campaigns.length?(
                <Col span={24}
                  className="mt-3 mt-1 p-0">
                  <div className="d-flex flex-wrap">
                    <CampaignCountsComponent/>
                    {/* <CampaignEarningsComponent title="Earning" amount={user.totalEarnings || 'N/A'} subtitle="In last month" className="text-center" loading={loading}/> */}
                    <CampaignCreditsComponent title="Wallet"
                      subtitle="Balance"
                      className="text-center"/>
                  </div>
                </Col>
              ):null
            }
            {campList.campaigns.length?(
              <>
                <Col span={12}
                  className="mt-4">
                  <h4>Your Campaigns</h4>
                </Col>
                <Col span={12}
                  className="text-right mt-4">
                  <Link to={`/brand/${params.companyId}/campaign`}
                    className="common_button">View All Campaigns</Link>
                </Col>
              </>
            ):null
            }
            {campList.campaigns.length ?
              (campList.campaigns.map((camp, index)=>{
                if (index < 3) {
                  return (<CampaignCardComponent
                    key={camp._id}
                    status={camp.campaignstatus}
                    timeLeft={camp.startdate? moment(camp.startdate).fromNow(): 'N/A'}
                    createdOn={camp.createdAt}
                    title={camp.name}
                    campaignid={camp.campaignid}
                    deleteCampaign={deleteDraft}
                    socialIcons={<>
                      <PlatformIconRender platform={camp.platform}
                        size={30}/>
                      {/* <span>
                                                {renderPlatform(camp.platform)}
                                            </span> */}
                      {/* <span>
                                                <FaInstagram/>
                                            </span> */}
                    </>}
                    taskCount={`Total of ${camp.totalcreatives} creatives`}
                    rowData={camp}
                  />);
                }
              })) :
              null
            }
          </Row>
        </div>
      )}
    </BrandBaseLayoutComponent>
  );
};
